import { Helmet } from "react-helmet-async";
import ContactSection from "../components/ContactSection";

export default function ContactPage() {
  return (
    <>
      <Helmet>
        <title>Contact | Nexalus Infotech</title>
        <meta
          name="description"
          content="Contact Nexalus Infotech in Ahmedabad for ELV and ICT consultations, quotes, and support."
        />
      </Helmet>
      <main className="pt-24">
        <ContactSection />
      </main>
    </>
  );
}
